import { _ } from "../../../core/polyglot/polyglot.js";
import { modulo } from "@foretagsplatsen/core-helpers/number";
import AbstractPeriodColumnTemplate from "../../reports/templates/columnTemplates/AbstractPeriodColumnTemplate.js";
import MonthPeriod from "../MonthPeriod.js";

/**
 * Represent a column template for a forecast column. The subclasses represent different
 * kinds of column templates.
 *
 * @abstract
 */
export default class AbstractForecastColumnTemplate extends AbstractPeriodColumnTemplate {
	_interpretationSpec(interpreter) {
		const spec = super._interpretationSpec(...arguments);

		spec.start = new MonthPeriod(
			this._makeStartPeriodSpec({
				context: interpreter.getContext(),
			}),
		);

		return spec;
	}

	_makeStartPeriodSpec({ context }) {
		const period = context.getPeriod();
		const monthIndex = period.getStart().getMonth();
		const periodIndex = period.getPeriodIndex() - 1;
		const periodYear = period.getStart().getFullYear();
		const lastMonthIndex = period.getYear().getLastMonthIndex() + 1;

		const shift = this.getPeriodTemplate().getShift();
		const calendarIndex = 1 + modulo(monthIndex + shift, 12);
		const index = 1 + modulo(periodIndex + shift, 12);
		const year =
			periodYear - Math.floor(-(1 + monthIndex + shift) / 12) - 1;
		const isClosing = calendarIndex === lastMonthIndex;

		return { calendarIndex, index, year, isClosing };
	}

	static getLabel() {
		return _("Period");
	}
}
